import { MediaCard } from './MediaCard'
import type { MediaDocument } from '../../services/admin.media.service'

interface MediaGridProps {
  items: MediaDocument[]
  loading: boolean
  selectedId: string | null
  onSelect: (item: MediaDocument) => void
  compact?: boolean
}

export function MediaGrid({ items, loading, selectedId, onSelect, compact }: MediaGridProps) {
  const gridClass = compact
    ? 'grid grid-cols-2 gap-3'
    : 'grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5'

  if (loading) {
    return (
      <div className={gridClass}>
        {Array.from({ length: 10 }).map((_, i) => (
          <div key={i} className="aspect-square animate-pulse rounded-lg bg-muted" />
        ))}
      </div>
    )
  }

  if (items.length === 0) {
    return (
      <div className="flex h-40 items-center justify-center rounded-lg border border-dashed text-sm text-muted-foreground">
        No media in this folder. Drop files above to upload.
      </div>
    )
  }

  return (
    <div className={gridClass}>
      {items.map((item) => (
        <MediaCard
          key={item.id}
          item={item}
          selected={selectedId === item.id}
          onClick={() => onSelect(item)}
        />
      ))}
    </div>
  )
}
